export const YesNo = Object.freeze({
    true: Symbol('Yes'),
    false: Symbol('No'),
});

export function getYesNoName(value) {
    return {
        [YesNo[true]]: 'Tak',
        [YesNo[false]]: 'Nie',
    }[YesNo[value]];
}